module.exports = __webpack_public_path__ + "static/6802c6c5-0e76-46d0-a3e8-2f56e70ab8bb-5d1b1b2d782ed385667ba2c22a47b1f6.webp";